import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PsychologyRoundedIcon from '@mui/icons-material/PsychologyRounded';
import SpeedRoundedIcon from '@mui/icons-material/SpeedRounded';
import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded';
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded';
import CloudDoneRoundedIcon from '@mui/icons-material/CloudDoneRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';

const items = [
  {
    icon: <PsychologyRoundedIcon />,
    title: 'AI Precision',
    description:
      'Embedding-powered resume–job matching with cosine similarity ensures accurate and unbiased scoring.',
  },
  {
    icon: <SpeedRoundedIcon />,
    title: 'Faster Hiring',
    description:
      'Automated parsing and instant scoring cut down resume screening time by over 50%.',
  },
  {
    icon: <SecurityRoundedIcon />,
    title: 'Enterprise-Grade Security',
    description:
      'JWT authentication, role-based access control, and encryption keep data safe.',
  },
  {
    icon: <InsightsRoundedIcon />,
    title: 'Real-Time Insights',
    description:
      'Recruiters and candidates get instant feedback and match percentages in the UI.',
  },
  {
    icon: <CloudDoneRoundedIcon />,
    title: 'Scalable Deployment',
    description:
      'Dockerized architecture ensures easy deployment and scaling across environments.',
  },
  {
    icon: <SupportAgentRoundedIcon />,
    title: 'Reliable Support',
    description:
      'Responsive support and future roadmap for analytics, multi-language parsing, and integrations.',
  },
];

export default function Highlights() {
  return (
    <Box
      id="highlights"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        color: 'white',
        bgcolor: 'grey.900',
      }}
    >
      <Container
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: '100%', md: '60%' },
            textAlign: { sm: 'left', md: 'center' },
          }}
        >
          <Typography component="h2" variant="h4" gutterBottom>
            Why choose TalentRealm?
          </Typography>
          <Typography variant="body1" sx={{ color: 'grey.400' }}>
            TalentRealm is designed to simplify hiring for recruiters and job hunting for candidates. 
            From AI-powered resume analysis to secure authentication, our platform helps you find the perfect match — faster and smarter.
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {items.map((item, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <Stack
                direction="column"
                component={Card}
                spacing={1}
                useFlexGap
                sx={{
                  color: 'inherit',
                  p: 3,
                  height: '100%',
                  borderColor: 'hsla(220, 25%, 25%, 0.3)',
                  backgroundColor: 'grey.800',
                }}
              >
                <Box sx={{ opacity: '70%' }}>{item.icon}</Box>
                <div>
                  <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'grey.400' }}>
                    {item.description}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
